import { render } from "./FolderCreationModal.vue?vue&type=template&id=8f1df420"
import script from "./FolderCreationModal.vue?vue&type=script&lang=js"
export * from "./FolderCreationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__